module.exports = __webpack_public_path__ + "img/borderGardenWhite.edd1270d.svg";